<template>
  <a :id="prefix + 'prev-step'" v-if="!isFirstStep" class="btn btn-outline-primary btn-step" :href="previousRouteHref"><font-awesome-icon icon="angle-left" class="mr-2" /><span>Prev. Step</span></a>
</template>

<script>
  import routes from '../mixins/routes'

  export default {
    props: ['prefix'],

    mixins: [routes]
  }
</script>
